import { render } from "./VehiculesView.vue?vue&type=template&id=51242fc2&scoped=true"
import script from "./VehiculesView.vue?vue&type=script&lang=js"
export * from "./VehiculesView.vue?vue&type=script&lang=js"

import "./VehiculesView.vue?vue&type=style&index=0&id=51242fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51242fc2"]])

export default __exports__